export default __webpack_public_path__ + "static/media/beat.8e22217a.jpg";